import { Routes } from "@angular/router";
import { AdminLayoutComponent } from "./shared/components/layouts/admin-layout/admin-layout.component";

import { AuthGuard } from "./auth/auth.guard";

export const rootRouterConfig: Routes = [
	{
		path: "",
		redirectTo: "dashboard",
		pathMatch: "full",
	},
	{
		path: "",
		component: AdminLayoutComponent,
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		children: [
			{
				path: "dashboard",
				loadChildren: () =>
					import("./views/dashboard/dashboard.module").then(
						(m) => m.DashboardModule
					),
				data: { title: "Inicio", breadcrumb: "INICIO" },
			},
			{
				path: "cotizador-sctr",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Cotizador", breadcrumb: "Cotizador SCTR" },
			},
			{
				path: "tarifario-sctr",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Tarifario", breadcrumb: "Tarifario SCTR" },
			},
			{
				path: "cotizador",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Cotizador", breadcrumb: "Cotizador" },
			},
			{
				path: "tarifario",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Tarifario", breadcrumb: "Tarifario" },
			},
			{
				path: "bonos-masivos",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Bonos Masivos", breadcrumb: "Bonos Masivos" },
			},
			{
				path: "tarifario-acc-personales",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Tarifario", breadcrumb: "Tarifario AP/VG" },
			},
			{
				path: "cotizador-acc-personales",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Cotizador", breadcrumb: "Cotizador AP/VG" },
			},
			{
				path: "tarifario-vida-grupo",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Tarifario", breadcrumb: "Tarifario VG" },
			},
			{
				path: "cotizador-vida-grupo",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Cotizador", breadcrumb: "Cotizador VG" },
			},
			{
				path: "tarifario-vida-credito",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Tarifario", breadcrumb: "Tarifario Vida Crédito" },
			},
			{
				path: "tarifario-vigp",
				canActivate: [AuthGuard],
				loadComponent: () => import('./shared/iframe/iframe.component').then(m => m.IframeComponent),
				data: { title: "Tarifario", breadcrumb: "Tarifario Vida Inversión" },
			}
		],
	},
	{
		path: "**",
		redirectTo: "sessions/404",
	},
];
